<form
  [formGroup]="formData"
  novalidate
  (ngSubmit)="submit()"
  [ngClass]="{ submitted: submitted }"
>
  <div class="modal-header">
    <h4 class="modal-title">{{ pageTitle }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss('')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>First Name</label>
          <input type="text" class="form-control" formControlName="firstName" tabindex="1" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.firstName"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Phone Number 1</label>
          <input type="text" class="form-control" formControlName="phoneOne" tabindex="3" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Last Name</label>
          <input type="text" class="form-control" formControlName="lastName" tabindex="2" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.lastName"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Phone Number 2</label>
          <input type="text" class="form-control" formControlName="phoneTwo" tabindex="5" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Receiving Bank Name</label>
          <input
            type="text"
            class="form-control"
            formControlName="receivingBankName"
            tabindex="8"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.receivingBankName"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group">
          <label>Email Address</label>
          <input type="text" class="form-control" formControlName="email" tabindex="4" />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.email"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="form-group">
          <label>Receiving Bank Address</label>
          <input
            type="text"
            class="form-control"
            formControlName="receivingBankAddress"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.receivingBankAddress"
          >
          </control-messages>
        </div>
      </div>
      <div class="col-md-6">
        <div class="form-group" *ngIf="!clientUser">
          <label
            >Password <small>Add password to enable B2b Portal login</small></label
          >Password
          <input
            type="text"
            class="form-control"
            formControlName="password"
            [maxlength]="passMaxLength"
            tabindex="7"
          />
          <control-messages
            [submitted]="submitted"
            [control]="formData.controls.password"
            [minlength]="passMinLength"
            [maxlength]="passMaxLength"
            [errorType]="'password'"
          >
          </control-messages>
        </div>
      </div>
    </div>
    <div class="form-group">
      <label for="">Sales Rep Assignee</label>
      <ng-select
        [items]="companyService.assignee$ | async"
        [searchFn]="customSearchFn"
        [multiple]="true"
        [closeOnSelect]="true"
        bindLabel="assignees"
        bindValue="id"
        [searchable]="true"
        [(ngModel)]="assignees"
        [hideSelected]="true"
        formControlName="salesRepAssigneeIds"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <span class="ng-value-label">
            {{ item.firstName }} {{ item.lastName }} ({{ item.email }})
          </span>
          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true"
            >×</span
          >
        </ng-template>
        <ng-template
          ng-option-tmp
          let-item="item"
          let-index="index"
          let-search="searchTerm"
        >
          <div>{{ item.firstName }} {{ item.lastName }} ({{ item.email }})</div>
        </ng-template>
      </ng-select>
    </div>

    <!-- NEW COMPANY FORM -->
    <div *ngIf="!clientUser" formArrayName="settings">
      <hr />
      <div
        class="row"
        *ngFor="let setting of settingsControl.controls; let i = index"
        [formGroupName]="i"
      >
        <div *ngIf="i > 0" class="col-12"><hr /></div>
        <div class="col-10 col-lg-11">
          <div class="form-group" *ngIf="!cliendt">
            <label for="">
              <b>Company #{{ i + 1 }}</b></label
            >
            <input
              placeholder="Search Company..."
              type="text"
              class="form-control input-chip"
              #companyInput
              [matAutocomplete]="auto"
              (input)="onCompanyInputChange($event)"
              formControlName="businessAccountId"
            />
            <mat-autocomplete
              autoActiveFirstOption
              #auto="matAutocomplete"
              [displayWith]="displayFn"
            >
              <mat-option
                disabled
                class="loading"
                *ngIf="companyLoading$ | async; else companyList"
              >
                <mat-spinner diameter="25"></mat-spinner>
              </mat-option>
              <ng-template #companyList>
                <mat-option
                  *ngFor="let company of filteredCompanies; trackBy: trackById"
                  [value]="company"
                >
                  {{ company?.business_name }}
                </mat-option>
              </ng-template>
            </mat-autocomplete>
          </div>

          <div *ngIf="setting.value.businessAccountId?.id">
            <div class="form-group">
              <div>
                <mat-checkbox formControlName="primaryContact">
                  Set this user as <b>Company</b> primary contact
                </mat-checkbox>
              </div>
            </div>
            <div
              *ngIf="!settingsControl.value[i].primaryContact"
              class="form-group"
            >
              <h6>Allowed client contact notifications</h6>
              <div class="row">
                <div class="col-lg-6">
                  <div>
                    <mat-checkbox formControlName="receiveQuotationPdf">
                      Receive Client Quotation Email
                    </mat-checkbox>
                  </div>
                  <div>
                    <mat-checkbox formControlName="receivePurchaseOrderPdf">
                      Receive Client Purchase Order Email
                    </mat-checkbox>
                  </div>
                </div>

                <div class="col-lg-6">
                  <mat-checkbox formControlName="receivePurchaseOrderInvoicePdf">
                    Receive Client Purchase Order Invoice Email
                  </mat-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-2 col-lg-1">
          <button
            type="button"
            class="lum-button lum-button--link mt-7"
            [aria-label]="'Remove Company #' + (i + 1)"
            [disabled]="settingsControl.controls.length <= 1"
            [title]="
              settingsControl.controls.length <= 1
                ? 'New contacts must be associated with a company'
                : 'Remove Company #' + (i + 1)
            "
            (click)="removeCompany(i)"
          >
            <icon name="close-circle" role="presentation"></icon>
          </button>
        </div>
      </div>
    </div>

    <div *ngIf="!clientUser && !client" class="add-company-container">
      <button
        type="button"
        class="lum-button lum-button--dotted lum-button--full-width"
        (click)="addCompany()"
      >
        <i class="fas fa-plus"></i>
        Add Another Company
      </button>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-default mr-1"
      type="button"
      (click)="activeModal.dismiss('')"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="submit"
      [disabled]="loading"
      [ngClass]="{
        'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
      }"
    >
      Submit
    </button>
  </div>
</form>
